<template>
	<div id="app">
		<el-container>
			<el-header style="height: 100px;">
				<div class="logo">
					<img src="./assets/img/toplogo.jpg" @click="homepage" />
				</div>
				<div class="bannerRight" v-if="isFirsPage">
					<div class="codeBox">
						<div id="qrcode" title="班主任手机扫码登录班级网页!"></div>
					</div>
					<div class="FPLog">
						<el-form ref="lform" :model="loginform" :rules="rules" label-width="10px">
							<!-- 第一行 -->
							<el-form-item>
								<div class="form-row">
									<img src="./assets/img/ane_user_1.png" alt="placeholder" class="image" />
									<el-input name="name" v-model="loginform.name" placeholder="请输入用户名"
										style="width:150px"></el-input>
									<el-button type="primary" @click="login">登录</el-button>
								</div>
							</el-form-item>

							<!-- 第二行 -->
							<el-form-item>
								<div class="form-row">
									<img src="./assets/img/ane_pwd_2.png" alt="placeholder" class="image" />
									<el-input name="password" type="password" v-model="loginform.pass"
										placeholder="请输入密码" :readonly="passwordReadonly"
										@focus="passwordReadonly = false" autocomplete="off" style="width:150px">
									</el-input>
									<el-button type="danger" @click="logout2">登出</el-button>
								</div>
							</el-form-item>
						</el-form>
					</div>
				</div>
				<div class="searchBox" v-if="isLoggedIn">
					<el-row type="flex" justify="start">
						<el-col :span="15" v-if="checkLimit('056')">
							<el-input v-model="searchStr" placeholder="输入学生姓名查询信息"></el-input>
						</el-col>
						<el-col :span="4" style="padding-left: 2px;" v-if="checkLimit('056')">
							<el-button type="primary" icon="el-icon-search" @click="handleSearch">查找</el-button>
						</el-col>
					</el-row>
				</div>
			</el-header>
			<el-main>
				<router-view />
			</el-main>
			<div class="footer">
				<span>CopyRight © 温州恒创教育服务有限公司-德育云 咨询电话:157 0677 0996 </span>
				<a href="https://beian.miit.gov.cn/" target="_blank" style="cursor:pointer">备案号:浙ICP备2025189321号</a>
			</div>
		</el-container>
	</div>
</template>

<script>
	import {
		md5
	} from './js/JSMD5.js';
	import {
		myFunctions
	} from './js/subcode.js';
	//import QRCode from 'qrcodejs2';
	import QRCode from 'qrcode';
	export default {
		data() {
			return {
				passwordReadonly: true,
				IfClass: true,
				ws: null,
				message: '',
				router: true,
				defaultActive: "",
				isLoggedIn: false,
				isFirsPage: true,
				username: sessionStorage.getItem("UserName"),
				searchStr: '',
				loginform: {
					name: "",
					pass: ""
				},
				rules: {
					name: [{
						required: true,
						message: "请输入用户名",
						trigger: "blur"
					}],
					pass: [{
							required: true,
							message: "请输入密码",
							trigger: "blur"
						},
						{
							min: 5,
							max: 20,
							message: "密码长度在 5 到 20 个字符",
							trigger: "blur"
						}
					]
				},
				idleTimer: null,
				idleTimeout: 10 * 60 * 1000, // 10分钟
				idleEvents: ['mousemove', 'mousedown', 'click', 'keydown', 'scroll', 'touchstart']
			};
		},
		mounted() {
			this.getInitializeData();
			this.checkClassLogin();
			this.checkClass();
			this.startIdleMonitoring();
		},
		beforeDestroy() {
			if (this.ws) {
				this.ws.close();
				console.log('WebSocket关闭成功!');
			} else {
				console.log('WebSocket关闭状态!');
			}
			this.stopIdleMonitoring();
		},
		methods: {
			// ========== 空闲检测相关方法 ==========
			shouldCheckIdle() {
				const currentPath = this.$route.path;
				if (/\/admin\/class\/class_/i.test(currentPath)) {
					return false;
				}
				const token = sessionStorage.getItem('token');
				return token && !currentPath.includes('/login');
			},
			// 启动空闲监控
			startIdleMonitoring() {
				this.bindIdleEvents();
				this.resetIdleTimer();
			},

			// 停止空闲监控
			stopIdleMonitoring() {
				this.unbindIdleEvents();
				this.clearIdleTimer();
			},

			// 绑定事件监听
			bindIdleEvents() {
				this.idleEvents.forEach(event => {
					window.addEventListener(event, this.resetIdleTimer);
				});
			},

			// 解绑事件监听
			unbindIdleEvents() {
				this.idleEvents.forEach(event => {
					window.removeEventListener(event, this.resetIdleTimer);
				});
			},

			// 重置计时器
			resetIdleTimer() {
				if (this.shouldCheckIdle()) {
					this.clearIdleTimer();
					this.startIdleTimer();
				}
			},

			// 启动计时器
			startIdleTimer() {
				if (this.shouldCheckIdle()) {
					this.idleTimer = setTimeout(() => {
						this.handleIdleLogout();
					}, this.idleTimeout);
				}
			},

			// 清除计时器
			clearIdleTimer() {
				if (this.idleTimer) {
					clearTimeout(this.idleTimer);
					this.idleTimer = null;
				}
			},

			// 处理空闲登出
			handleIdleLogout() {
				if (this.shouldCheckIdle()) {
					const token = sessionStorage.getItem('token');
					if (token && !this.$route.path.includes('/login')) {
						sessionStorage.clear();
						localStorage.removeItem('token');
						this.$message({
							message: "由于长时间未操作，已自动退出登录",
							type: "warning"
						});
						this.$LoginName.value = '';
						this.$router.push('/login');
					}
				}
			},

			// ========== 原有方法 ==========

			checkLimit(openLimit) {
				const limitStr = sessionStorage.getItem('UserLimit')?.toString() || '';
				const limitList = limitStr.split('');
				const openLimitStr = openLimit.toString();
				var flag = false;
				for (let i = 0; i < limitList.length; i++) {
					if (openLimitStr.indexOf(limitList[i]) >= 0) {
						flag = true;
						return flag;
					}
				}
				return flag;
			},

			// 删除原有的 checkEvent 方法（已被新方法替代）

			async getInitializeData(schoolCode) {
				const getSysweekList = await myFunctions.getCloudDataFunction(this, this.$options.httpOptions,
					'getSysWeekList', 'null');
				const weeksListStr = JSON.stringify(getSysweekList)
				sessionStorage.setItem("sysWeekList", weeksListStr);
			},

			checkClass() {
				const classLimit = sessionStorage.getItem('UserLimit');
				if (classLimit == '8') {
					this.IfClass = false;
				}
			},
			createQRcode(clientId) {
				// 如果已经登录成功，不再生成二维码
				if (sessionStorage.getItem('token')) {
					console.log('用户已登录，不再生成二维码');
					return;
				}

				this.$nextTick(() => {
					const qrcodeDiv = document.getElementById("qrcode");
					if (qrcodeDiv) {
						qrcodeDiv.innerHTML = '';
						const canvas = document.createElement('canvas');
						qrcodeDiv.appendChild(canvas);
						QRCode.toCanvas(canvas, clientId, {
							width: 88,
							margin: 2,
							color: {
								dark: '#00aa00', // 深色块颜色（原来是 colorDark）
								light: '#ffffff' // 浅色块颜色（原来是 colorLight）
							},
							errorCorrectionLevel: 'H' // 高纠错级别（对应原来的 CorrectLevel.H）
						}, function(error) {
							if (error) {
								console.error('二维码生成失败:', error);
							} else {
								console.log('二维码生成成功');
							}
						});
					} else {
						// 只在未登录且未跳转页面时重试
						if (!sessionStorage.getItem('token') && this.isFirsPage) {
							console.warn('qrcode元素不存在，100ms后重试');
							setTimeout(() => this.createQRcode(clientId), 100);
						} else {
							console.log('用户已登录或已离开首页，停止二维码生成');
						}
					}
				});
			},
			createQRcodeBak(clientId) {
				// 如果已经登录成功，不再生成二维码
				if (sessionStorage.getItem('token')) {
					console.log('用户已登录，不再生成二维码');
					return;
				}

				this.$nextTick(() => {
					const qrcodeDiv = document.getElementById("qrcode");
					if (qrcodeDiv) {
						qrcodeDiv.innerHTML = '';
						try {
							new QRCode(qrcodeDiv, {
								text: clientId,
								width: 88,
								height: 88,
								colorDark: "#00aa00",
								colorLight: "#ffffff",
								correctLevel: QRCode.CorrectLevel.H
							});
							console.log('二维码生成成功');
						} catch (error) {
							console.error('二维码生成失败:', error);
						}
					} else {
						// 只在未登录且未跳转页面时重试
						if (!sessionStorage.getItem('token') && this.isFirsPage) {
							console.warn('qrcode元素不存在，100ms后重试');
							setTimeout(() => this.createQRcode(clientId), 100);
						} else {
							console.log('用户已登录或已离开首页，停止二维码生成');
						}
					}
				});
			},

			checkClassLogin() {
				const ClassInfo = localStorage.getItem('localClassInfo');
				const sessionClassInfo = JSON.parse(ClassInfo);
				if (sessionClassInfo) {
					if (sessionClassInfo.Headteacher) {
						this.defaultClassSession(sessionClassInfo);
					} else {
						console.log('没有班级信息');
					}
				} else {
					this.handleTableMounted();
				}
			},

			handleTableMounted() {
				this.$nextTick(() => {
					this.connect();
				});
			},

			connect() {
				this.ws = new WebSocket('wss://wzdyy.com:8088');
				this.ws.onopen = () => {
					console.log('WebSocket连接已打开');
					this.connectWebSocket();
				};
				this.ws.onmessage = (event) => {
					this.message = event.data;
					const connectMessage = JSON.parse(event.data);
					if (connectMessage.statue == 'handshake') {
						console.log('服务器握手成功收到邀请码:' + connectMessage.clientId);
						this.createQRcode(connectMessage.clientId);
					} else if (connectMessage.statue == 'moralLogin') {
						localStorage.setItem("localClassInfo", JSON.stringify(connectMessage));
						this.defaultClassSession(connectMessage);
						if (connectMessage.Headteacher) {
							this.$message({
								message: "扫码成功，将跳到班级网页!",
								type: "success"
							});
						} else {
							this.$message({
								message: "没有班主任信息，无法登录！",
								type: "fail"
							});
						}
					} else {
						console.log('收到服务器推送的其他信息:' + connectMessage);
					}
				};
				this.ws.onerror = (error) => {
					console.error('WebSocket发生错误:', error);
				};
				this.ws.onclose = () => {
					console.log('WebSocket连接已关闭');
				};
			},

			defaultClassSession(ui) {
				const {
					currentWeek,
					currentDay,
					currentWeekDay
				} = this.getCurrentWeekAndDay(ui.StartDate, ui.StartWeek)

				// 批量存储
				this.batchSetSessionStorage({
					token: ui.toClientId,
					ClassCode: ui.Headteacher,
					ClassName: ui.ClassName,
					currentWeek: currentWeek,
					currentWeekDay: currentWeekDay,
					currentDay: currentDay,
					Term: ui.Term,
					Year: ui.Year,
					UserName: ui.UserName,
					UserId: ui.UserID,
					SchoolCode: ui.SchoolCode,
					SchoolName: ui.SchoolName,
					UserLimit: '8',
					StartDate: ui.StartDate,
					StartWeek: ui.StartWeek,
					SchoolType: ui.SchoolType,
					SchoolUnit: ui.EvaUnit,
					loginTime: Date.now() // 添加登录时间
				});
				// 关闭 WebSocket 连接
				if (this.ws) {
					this.ws.close();
					this.ws = null;
					console.log('WebSocket连接已关闭（班级登录成功后）');
				}
				this.$router.push({
					name: 'class_index',
					path: '/admin/Class/class_index',
				});
			},


			// 批量存储辅助方法
			batchSetSessionStorage(dataMap) {
				Object.entries(dataMap).forEach(([key, value]) => {
					if (value !== undefined && value !== null) {
						sessionStorage.setItem(key, value);
					}
				});
			},

			connectWebSocket() {
				if (this.ws.readyState === WebSocket.OPEN) {
					const urlData = {
						statue: 'handshake'
					};
					const connectMessage = JSON.stringify(urlData);
					this.ws.send(connectMessage);
				} else {
					console.log('WebSocket连接未打开');
				}
			},

			homepage() {
				this.$router.push({
					name: 'default',
					path: '/admin/default',
				});
			},

			logout() {
				sessionStorage.clear();
				this.$LoginName.value = '';
				this.$router.push('/login');
			},

			logout2() {
				sessionStorage.clear();
				this.$LoginName.value = '';
				this.$message({
					message: "登录信息凭证已清除",
					type: "success"
				});
			},

			async handleSearch() {
				this.$router.push({
					path: '/admin/studentSearchResult',
					query: {
						studentName: this.searchStr,
					}
				});
			},

			login() {
				this.$refs.lform.validate(valid => {
					if (valid) {
						const formData = {
							username: this.loginform.name,
							password: md5.hexMD5(this.loginform.pass),
						};
						this.$http.post('/Login', formData)
							.then(response => {
								if (response.data.success) {
									this.$message({
										message: `登录成功!欢迎您${this.loginform.name}老师！`,
										type: "success"
									});
									const {
										currentWeek,
										currentDay,
										currentWeekDay
									} = this.getCurrentWeekAndDay(response.data.schoolData.StartDate, response
										.data.schoolData.StartWeek)

									this.batchSetSessionStorage({
										token: response.data.token,
										currentWeek: currentWeek,
										currentWeekDay: currentWeekDay,
										StartDate: response.data.schoolData.StartDate,
										StartWeek: response.data.schoolData.StartWeek,
										currentDay: currentDay,
										Term: response.data.schoolData.Term,
										Year: response.data.schoolData.Year,
										UserName: this.loginform.name,
										UserId: response.data.schoolData.TIid,
										SchoolCode: response.data.schoolData.SchoolCode,
										UserLimit: response.data.schoolData.UserCategorys,
										SchoolType: response.data.schoolData.SchoolType,
										SchoolUnit: response.data.schoolData.EvaUnit,
										loginTime: Date.now() // 添加登录时间
									});

									// 关闭 WebSocket 连接
									if (this.ws) {
										this.ws.close();
										this.ws = null;
										console.log('WebSocket连接已关闭（账号密码登录成功后）');
									}

									this.$router.push('/admin/default')
									this.$LoginName.value = this.loginform.name;
								} else {
									this.$message({
										message: "账号或密码错误",
										type: "error"
									});
								}
							})
							.catch(error => {
								window.console.log(error);
								if (error.response) {
									this.$message({
										message: "请求错误：" + error.response.data.message,
										type: "error"
									});
								} else {
									this.$message({
										message: "网络或程序异常：" + error.message,
										type: "error"
									});
								}
							});
					} else {
						this.$message({
							message: "请输入合法的值",
							type: "error"
						});
						return false;
					}
				});
			},

			getCurrentWeekAndDay(StartTime, Week) {
				const weekDayList = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
				const startTimestamp = new Date(StartTime).getTime();
				const startTimestampPlus8Hours = startTimestamp + (8 * 60 * 60 * 1000);
				const currentTimestamp = Date.now();
				const timeDiff = currentTimestamp - startTimestampPlus8Hours;
				const passedWeeks = Math.floor(timeDiff / (1000 * 60 * 60 * 24 * 7));
				const currentWeek = Week + passedWeeks;
				let currentDay = new Date().getDay();
				let currentWeekDay = weekDayList[currentDay];
				return {
					currentWeek,
					currentDay,
					currentWeekDay
				};
			},
		},
		watch: {
			$route(to, from) {
				if (to.path.startsWith('/admin')) {
					this.isLoggedIn = true && this.IfClass;
					this.resetIdleTimer();
				} else {
					this.isLoggedIn = false;
					this.clearIdleTimer();
				}
				if (to.path === '/') {
					this.isFirsPage = true;
				} else {
					this.isFirsPage = false;
				}
			},
			'$LoginName.value'(newVal) {
				this.username = newVal
			},
		},
	};

	const debounce = (fn, delay) => {
		let timer = null;
		return function() {
			let context = this;
			let args = arguments;
			clearTimeout(timer);
			timer = setTimeout(function() {
				fn.apply(context, args);
			}, delay);
		};
	};

	const _ResizeObserver = window.ResizeObserver;
	window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
		constructor(callback) {
			callback = debounce(callback, 16);
			super(callback);
		}
	};
</script>

<style lang="scss">
	* {
		padding: 0;
		margin: 0;
	}

	html,
	body {
		height: 100%;
	}

	#app {
		height: 100vh;
		/* ← 改这里：100% 改成 100vh */
		font-family: "Avenir", Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: #2c3e50;
	}

	.el-header {
		display: flex;
		justify-content: space-between;
		align-content: center;
		width: 100%;
		margin: 0 auto;

		.logo {
			padding: 10px 0px;

			img {
				width: 100%;
				line-height: 60px;
			}
		}

		.Login {
			margin-top: 18px;
		}
	}

	.el-main {
		flex: 1;
		/* ← 加这一行 */
		overflow-y: auto;
		/* ← 加这一行 */
		padding: 0 !important;
	}

	.footer {
		flex-shrink: 0;    /* ← 加这一行 */
		font-size: 20px;
		font-weight: 200;
		color: #333;
		text-align: center;
		background-color: rgb(1, 125, 163);
		height: 60px;
		line-height: 60px;
		color: white;


		a:visited {
			color: #ffffff;
			text-decoration: none;
		}

		a:hover {
			text-decoration: none;
		}

		a {
			text-decoration: none;
		}
	}

	.searchBox {
		padding-top: 25px;

	}


	.FPLog {
		padding: 0px;
		margin: 0px;

		.form-row {
			display: flex;
			align-items: center;
			margin: 5px 0px;
		}


		.el-input {
			flex: 1;
			margin-right: 5px;
		}

		.el-button {
			margin-left: 5px;
		}

		.el-form-item {
			margin: 0px;
		}

		image {
			width: 40px;
			height: 40px;
		}
	}

	.QRcode {
		margin-right: 10px;
		width: 30%;
		height: auto;
	}

	.codeBox {
		display: flex;
		justify-content: flex-end;
		/* 添加这一行以实现右对齐 */
		/* 如果需要，还可以添加align-items来控制交叉轴上的对齐方式 */
		align-items: center;
		/* 例如，使子元素在交叉轴上居中对齐 */
	}

	.bannerRight {
		display: flex;
	}
</style>